export default "__VITE_ASSET__43001539__"